const CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutes
const STORAGE_KEY = 'manager_last_activity_cache';

function writeCache(cache) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch { /* ignore storage errors */ }
}

function readCache() {
  try {
    const cache = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    const now = Date.now();
    const pruned = Object.fromEntries(
      Object.entries(cache).filter(([, entry]) => now - entry.ts <= CACHE_TTL_MS),
    );
    if (Object.keys(pruned).length !== Object.keys(cache).length) {
      writeCache(pruned);
    }
    return pruned;
  } catch {
    return {};
  }
}

export function getCachedActivity(venueId) {
  const entry = readCache()[venueId];
  return entry ? entry.value : false;
}

export function getCachedActivities(venueIds) {
  const cache = readCache();
  const cached = {};
  const staleIds = [];
  [...new Set(venueIds)].forEach(id => {
    const entry = cache[id];
    if (entry) {
      cached[id] = entry.value;
    } else {
      staleIds.push(id);
    }
  });
  return { cached, staleIds };
}

export function setCachedActivities(entries) {
  const cache = readCache();
  const ts = Date.now();
  Object.entries(entries).forEach(([id, value]) => {
    cache[id] = { ts, value };
  });
  writeCache(cache);
}

export function setCachedActivity(venueId, value) {
  setCachedActivities({ [venueId]: value });
}
